import React from 'react';
import Intro from '../components/wiki/Intro/Intro';

const IntroPage = () => {
  return <Intro />;
};

export default IntroPage;
